import consumer from '../../channels/consumer';
import StimulusReflex from 'stimulus_reflex';
import Cookies from 'js-cookie';
import {updateCartCount, copyToClipboard, initSlider, overrideLinkTargets} from '../../public/common';

import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['barcode', 'card', 'paymentProcessing', 'copyLink', 'details'];
  static values = { deliveryDelay: Number };

  connect() {
    StimulusReflex.register(this);

    const controller = this;
    const order = document.getElementById('order');

    consumer.subscriptions.create({ channel: 'Ia3::Common::OrderChannel', token: order.dataset.token }, {
      received() {
        controller.stimulate('Ia3::Common::ApplicationReflex#default_reflex', { selectors: '.wrapper' });
      }
    });

    if (this.hasPaymentProcessingTarget) {
      setTimeout(() => this.showPaymentProcessing(), this.deliveryDelayValue * 500);
    }
  }

  initialize() {
    if (this.hasDetailsTarget) {
      overrideLinkTargets({
        $containerEl: this.detailsTarget
      });
    }
  }

  afterReflex() {
    this.barcodeTargets.forEach(target => JsBarcode(target).init());
    this.cardTargets.filter(card => card.dataset.status === 'active')
      .forEach(card => this.removeFromCart(card.dataset.stockedProductId, card.dataset.denomId, card.dataset.phone));

    this.sendConversionEvents();
    this.clearAgeVerification();
    initSlider();
  }

  removeFromCart(stockedProductId, denomId, phone) {
    const cart = JSON.parse(Cookies.get('cart') || '{}');
    const rtrCart = JSON.parse(Cookies.get('rtr_products_in_cart') || '{}');
    const merchantsCount = document.getElementsByTagName('body')[0].dataset.merchantsCount;
    const merchantPath = (merchantsCount > 1) ? `/${location.pathname.split('/')[1]}` : '/';
    let removeDenomFromCart = true;

    if (phone && rtrCart[denomId]) {
      if (rtrCart[denomId].length === 1) {
        delete rtrCart[denomId];
      } else {
        rtrCart[denomId] = rtrCart[denomId].filter(e => e !== phone);
        removeDenomFromCart = false;
      }
    }

    if (removeDenomFromCart && cart[stockedProductId]) {
      if (cart[stockedProductId].length === 1) {
        delete cart[stockedProductId];
      } else {
        cart[stockedProductId] = cart[stockedProductId].filter(e => e !== denomId);
      }
    }

    Cookies.set('cart', JSON.stringify(cart), { path: merchantPath });
    Cookies.set('rtr_products_in_cart', JSON.stringify(rtrCart), { path: merchantPath });
    updateCartCount(-1);
  }

  showPaymentProcessing() {
    this.element.querySelectorAll('.item-detailed').forEach(item => item.style.opacity = 0.2);
    this.paymentProcessingTarget.classList.add('d-block');
  }

  clearAgeVerification() {
    Cookies.remove('age_verified');
  }

  sendConversionEvents() {
    if (!window.gtag) return;

    this.cardTargets.filter(card => typeof card.dataset.conversionEvent === 'string').forEach(card => {
      gtag('event', 'conversion', JSON.parse(card.dataset.conversionEvent));
    });
  }
}
